"use strict";

import {onFind} from "@elements/init-modules-in-scope";
import {findIn, findAllIn, removeClass, on} from '@elements/dom-utils';
import {getApi} from "@elements/datepicker";

const selectors = {
    base: '.js-set-datepicker',
    btn: '.js-set-datepicker__btn',
    input: '.js-set-datepicker__input'
};

export function init () {
    onFind(selectors.base, function (baseElement) {
        let btn = findIn(selectors.btn, baseElement);
        let inputs = findAllIn(selectors.input, baseElement);

        on('click', function (evt) {
            evt.preventDefault();
            let newDate = btn.dataset.setDatepicker;

            if(newDate) {
                inputs.map(function(input) {
                    Promise.all([getApi(input)]).then(function([api]) {
                        api.setDate(new Date(newDate));
                    });

                })
            }

        }, btn);
    });
}
